import React, {useState} from "react";
import Logo from "../assets/image/splash-logo.svg"

function Splash() {

  return (
    <div className="splash">
      <img src={Logo} alt=""/>
    </div>
  );
}

export default Splash;
